import { gql } from '@apollo/client';

import { SchoolRequisitesFragment } from '@modules/schools/graphql';

export const GetCurrentUserQuery = gql`
    query GetCurrentUser {
        getCurrentUser {
            id
            username
            fullName
            email
            roles
            createdAt
            updatedAt
            student {
                id
                fullName
                olCourseCertificateUrl
            }
            school {
                id
                shortName
                fullName
                currentStudentsCount
                maxStudentsCount
                type
                region {
                    name
                }
                location {
                    name
                }
                requisites {
                    ...SchoolRequisites
                }
            }
            grants {
                category
                actions
            }
        }
    }
    ${SchoolRequisitesFragment}
`;
